import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import App from "./components/App";
import configureStore from "./redux/configureStore";
import { Provider as ReduxProvider } from "react-redux";
import { ChakraProvider } from "@chakra-ui/react";
import customTheme from "./theme";
import "./index.css";

const store = configureStore();

render(
	<ReduxProvider store={store}>
		<Router>
			<ChakraProvider theme={customTheme}>
				<DndProvider backend={HTML5Backend}>
					<App />
				</DndProvider>
			</ChakraProvider>
		</Router>
	</ReduxProvider>,
	document.getElementById("app")
);
